import * as bootstrap from "bootstrap"

window.addEventListener("turbo:frame-load", function(event) {
  const modalContainerId= 'modal_container';
  if (event.target.id==modalContainerId) {
    // console.log("Loading modal window");
    const modalElm= event.target.firstChild;
    const modalOptions={};

    if (modalElm) {
      // console.log(`Activating modal window ${modalElm.id}`);
      let modal = bootstrap.Modal.getOrCreateInstance(modalElm, modalOptions);
      if (modal) {
        // Remove any lost backdrop due to modal overlapping
        const bdElm= document.querySelector('aside.popups + .modal-backdrop.show');
        if (bdElm) bdElm.remove();

        modal.show();
      }
    }
  }
});
